import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BugReportingWrapper } from '@offerzen/react-utils'

import { MediaQueryProvider } from '@offerzen/pinata-shame'

import browserHistory from './CandidateExperience/config/browserHistory'
import configureStore from './CandidateExperience/config/store'
import ErrorUser from './CandidateExperience/containers/ErrorUser'
import rootSaga from './CandidateExperience/sagas'
import CandidateExperienceMain from './CandidateExperience/Main'
import CandidateExperienceError from './CandidateExperience/scenes/CandidateExperienceError'

const App = () => {
  const store = configureStore()
  store.registerSaga('root', rootSaga)

  const reactQueryClient = new QueryClient()

  return (
    <QueryClientProvider client={reactQueryClient}>
      <Provider store={store}>
        <ErrorUser>
          {({ errorUser }) => (
            <BugReportingWrapper
              errorHandlingEnabled={process.env.REACT_APP_ERROR_HANDLING_ENABLED === 'true'}
              errorHandlingEndpoint={process.env.REACT_APP_ERROR_HANDLING_ENDPOINT}
              fallback={<CandidateExperienceError user={errorUser} />}
              service="candidate-experience"
              environment={process.env.REACT_APP_ENVIRONMENT}
              releaseId={process.env.REACT_APP_APP_VERSION}
              user={errorUser}>
              <ConnectedRouter history={browserHistory}>
                <MediaQueryProvider>
                  <CandidateExperienceMain />
                </MediaQueryProvider>
              </ConnectedRouter>
            </BugReportingWrapper>
          )}
        </ErrorUser>
      </Provider>
      <If condition={process.env.NODE_ENV === 'development'}>
        <ReactQueryDevtools initialIsOpen={false} />
      </If>
    </QueryClientProvider>
  )
}

export default App
